import { useQuery } from '@tanstack/react-query';

import { chatbotRepository } from '../lib/repositories/chatbot.repository';
import type { ChatbotDisplay } from '../modules/dashboard/types';

/**
 * Danh sách chatbot, dùng để chèn mục `Trò chuyện với bot` vào thanh điều hướng.
 *
 * Component chỉ gọi hook, không bao giờ gọi repository hay axios trực tiếp
 * (§3.2). Đọc dữ liệu luôn dùng `useQuery` với `queryKey` dạng mảng và
 * `staleTime` tường minh.
 */
export function useChatbots() {
  return useQuery<ChatbotDisplay[]>({
    queryKey: ['chatbots'],
    queryFn: chatbotRepository.list,
    staleTime: 60_000,
  });
}
